module.exports = __webpack_public_path__ + "static/media/header.c7a72a2f.less";